//@flow
///* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */
import drawLerc from './draw_lerc_util';
import type Painter from "../../render/painter";

export default drawLercTerrain;

const drawTypes = {
    normal: 0,
    shadow: 1,
    slope: 2,
    '3d': 3,
    aspect: 4,
};

function getType(key) {
    return drawTypes[key] || 0;
}
function drawLercTerrain(painter: Painter, sourceCache, layer, coords) {
    drawLerc(painter, sourceCache, layer, coords, {
        programName: 'lerc-terrain',
        bindOtherParamFunc: bindTerrainParam,
    });
}
function bindTerrainParam(gl, program, layer, sourceCache) {
    // terrain å°å½¢ç»å¶
    const zoom = (sourceCache._source.roundZoom ? Math.round : Math.floor)(sourceCache.getZoom(sourceCache.transform));
    const currentZoom = Math.min(zoom, sourceCache._source.maxzoom);
    const tileSize = sourceCache._source.tileSize;
    gl.uniform1f(program.uniforms.u_zoom, currentZoom);
    gl.uniform1f(program.uniforms.u_tile_size, tileSize);
    gl.uniform1f(program.uniforms.u_zenith, layer.paint.get('zenith'));
    gl.uniform1f(program.uniforms.u_azimuth, layer.paint.get('azimuth'));
    gl.uniform1i(program.uniforms.u_draw_type, getType(layer.paint.get('draw-type')));
}
